import loginEntryDownload from 'BASE/components/downLoad/loginEntryDownload';
import download_component from '#BASE/components/downLoad/DownLoadCenter';

export default {
    mixins: [loginEntryDownload, download_component],
    props: {
        dialog: Object
    },
    data: function(){
        return {
            checkSettingComplete: true,
        };
    },
    methods: {
        showDownloadCenter(){
            let _dialog = this.$dialog.get('downloadcenter');
            _dialog.show();
        },
        closeDownloadCenter(){
            let _dialog = this.$dialog.get('downloadcenter');
            _dialog.hide();
        }
    }
}